// Define and export isIt
export const isIt = (pattern, url) => {
    return url === pattern || url.startsWith(`${pattern}?`);
};

// getTitleForLocation function
export const getTitleForLocation = (url, isMoney) => {
    let baseName = isMoney ? 'Flextagram ' : 'Flexagren ';

    if (!url) {
        return baseName;
    }

    if (isOnLocation(url, 'images')) {
        return baseName + 'Images';
    } else if (isOnLocation(url, 'loot')) {
        return baseName + 'Loot';
    } else if (isOnLocation(url, 'inventory')) {
        return baseName + 'Inventory';
    } else if (isOnLocation(url, 'store')) {
        return baseName + 'Store';
    } else if (isOnLocation(url, 'chat')) {
        return baseName + 'Chat';
    }
    return baseName.trim();
};

// isOnLocation function
export const isOnLocation = (url, locationName, userId) => {
    const lowerCaseLocationName = locationName.toLowerCase();
    if (!url) {
        return false;
    }
    const exactPageName = singlePageLocation(url);

    if (exactPageName === 'profile' && userId) {
        const isOnUserProfile = url.startsWith(`/profile/${userId}`);
        if (lowerCaseLocationName === 'profile') {
            return isOnUserProfile;
        }
        if (lowerCaseLocationName === 'the wall') {
            return !isOnUserProfile;
        }
    }

    switch (lowerCaseLocationName) {
        case 'the wall':
            return exactPageName === 'top' ||
                exactPageName === 'trending' ||
                exactPageName === 'image' ||
                exactPageName === 'profile';
        case 'lootbox':
            return exactPageName === 'lootbox';
        case 'inventory':
            return isIt('/my-items', url) || (url.startsWith('/items-detail/') && url.endsWith('/my-items'));
        case 'store':
            return isIt('/item-store', url) || (url.startsWith('/items-detail/') && url.endsWith('/item-store'));
        case 'chat':
            return exactPageName === 'chat';
        case 'notifications':
            return exactPageName === 'notifications' || exactPageName === 'mobile-notifications';
        case 'upload':
            return isIt('/upload', url);
        case 'profile':
            return isIt('/mobile-profile', url);
        default:
            return false;
    }
};

export const singlePageLocation = (url) => {
    if (isIt('/', url)) {
        return 'top';
    }
    if (isIt('/trending', url)) {
        return 'trending';
    }
    if (url.startsWith('/image/detail/') ||
        url.startsWith('/image/top/') ||
        url.startsWith('/image/trending/') ||
        url.startsWith('/image/profile/')) {
        return 'image';
    }
    if (url.startsWith('/profile') && !isIt('/profile/edit', url)) {
        return 'profile';
    }
    if (isIt('/upload', url)) {
        return 'upload';
    }
    if (isIt('/lootbox', url)) {
        return 'lootbox';
    }
    if (isIt('/my-items', url)) {
        return 'my-items';
    }
    if (isIt('/item-store', url)) {
        return 'item-store';
    }
    if ((url.startsWith('/items-detail/') && url.endsWith('/item-store')) || (url.startsWith('/items-detail/') && url.endsWith('/my-items'))) {
        return 'items-detail';
    }
    if (isIt('/chat', url)) {
        return 'chat';
    }
    if (isIt('/verify-email', url)) {
        return 'verify-email';
    }
    if (isIt('/notifications', url)) {
        return 'notifications';
    }
    if (isIt('/mobile-notifications', url)) {
        return 'mobile-notifications';
    }
    if (isIt('/swag', url)) {
        return 'swag';
    }
    if (isIt('/mobile-profile', url)) {
        return 'mobile-menu';
    }
    if (isIt('/profile/edit', url)) {
        return 'set-profile-picture';
    }
    if (url.startsWith('/history')) {
        return 'history';
    }
    if (url.startsWith('/page-rules')) {
        return 'page-rules';
    }
    return null;
};

export const getPageDescription = (url) => {
    if (!url) {
        return 'Flexagren';
    }
    const exactPageName = singlePageLocation(url);
    switch (exactPageName) {
        case 'top':
            return 'Discover images ranked by the highest contributions. The more paid, the higher it appears!';
        case 'trending':
            return 'The heat of the image. Recent money are the warmest.';
        case 'image':
            return 'Image details, with comments and reactions.';
        case 'profile':
            return 'Nice profile of the user, sorted by last author payments.';
        case 'upload':
            return 'Add new image to your profile. You can then comment it with all the letters.';
        case 'lootboxes':
            return 'Get random   letters & emojis to write with.';
        case 'my-items':
            return 'What you earned and own. Click to sell.';
        case 'item-store':
            return 'Unowned items are shown first. Click to buy.';
        case 'items-detail':
            return 'Sell. Buy. Investigate price changes.';
        case 'chat':
            return 'Write something with your items for everyone to see.';
        case 'notifications':
            return 'See what happened while you were away.';
        case 'set-profile-picture':
            return 'Set your profile picture. For free!';
        case 'history':
            return 'Where did the money run?';
        default:
            return 'Flexagren';
    }
};